/**
 * 路由级权限控制
 *
 * - isLoggedIn: 已登录用户可访问
 * - canAccessMenu: 检查后端返回的菜单树中是否包含当前路由
 *   用于防止用户通过直接输入 URL 访问未授权的页面
 */
export default function access(
  initialState:
    | {
        currentUser?: API.CurrentUser;
        menuTree?: API.RouteItemVO[];
      }
    | undefined
) {
  const { currentUser, menuTree } = initialState ?? {};

  // 从菜单树中提取所有被授权的路径
  const authorizedPaths = new Set<string>();
  // 始终允许的基础路径
  authorizedPaths.add("/dashboard");
  authorizedPaths.add("/settings");
  authorizedPaths.add("/pricing");

  function collectPaths(items?: API.RouteItemVO[]) {
    if (!items) return;
    for (const item of items) {
      if (item.path) {
        authorizedPaths.add(item.path);
      }
      if (item.children) {
        collectPaths(item.children);
      }
    }
  }
  collectPaths(menuTree);

  // 前端目录已重组到 pages/wms/*，URL 也加了 /wms 前缀；
  // 但 platform_sys_menu 还保留旧路径（/product、/stock 等）。
  // 临时把 /wms/<rest> 映射到 /<rest> 兜底检查；
  // 后端菜单 DB 迁移到 /wms/* 后，删除下面 isAuthorized 里的 wms 兜底分支即可。
  const isAuthorized = (path: string): boolean => {
    if (authorizedPaths.has(path)) return true;
    for (const p of authorizedPaths) {
      if (path.startsWith(p + "/")) return true;
    }
    return false;
  };

  return {
    isLoggedIn: !!currentUser,
    canAccessMenu: (route: { path?: string }) => {
      if (!currentUser) return false;
      if (!route.path) return true;
      if (isAuthorized(route.path)) return true;
      // TODO(backend-migration): /wms 前缀兜底，等 platform_sys_menu 迁移完后移除
      if (route.path.startsWith("/wms/")) {
        return isAuthorized(route.path.slice(4));
      }
      return false;
    },
  };
}
